import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/components/core/loading-page/loading-page.tsx");
